<template>
	<div id="loginbox">
		<div id="login">
			<div align="center">
				<img :src="logoImg" alt="Logo" width="150">
			</div>
			<h3>生涯周学生端登录</h3>
			<el-form
				ref="login"
				:model="form"
				label-width="0"
				style="width:100%;"
				@keydown.enter.native="submit"
			>
				<el-form-item prop="userID">
					<el-input v-model="form.userID" placeholder="请输入账号" type="text" class="user-selector">

					</el-input>
				</el-form-item>
        <!-- <el-form-item prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            type="password"
            show-password
            clearable
          ></el-input>
        </el-form-item> -->
				<el-button
					type="primary"
					@click="submit"
					class="btn-success"
					style="width:100%; margin-top: 6px;"
				>登录</el-button>
			</el-form>
		</div>
	</div>
</template>

<script>
import { Form, FormItem, Select, Option } from 'element-ui'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'LoginStudent',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    return {
      form: {
        userID: '',
        password: ''
      },
      registerVisible: false,
    }
  },
  computed:{
    logoImg() {
      return 'http://sys.rennengda.com/public/images/logo_01.png'
    }
  },
  methods: {
    submit() {
      this.login()
      // if (this.form.password == 'rnd!')

      // else
      //   this.$store.commit('showMessage', {
      //     message: '密码不对' ,
      //     type: 'error'
      //   })
    },
    login() {
          //生涯周模拟登录验证
          const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded'},
            data:qs.stringify({openId: this.form.userID}),
            url:'/cob/loginCos.do'
          }
          axios(options)
          .then( (res) => {
            res = res.data
            if (res.result.success) {
							var  shengyaUser = res.data
              store.dispatch('setUserInfo', shengyaUser)
              store.dispatch('setLoginStatus', 2)
              //到广场
              this.$router.push('/')
            }
            else{
              this.$store.commit('showMessage', {
                message: '生涯周登录失败：' ,
                type: 'error'
              })
            }
          })
    },
  }
}
</script>

<style lang="stylus" scoped>
#login-header {
    width: 100%;
    padding: 10px;
}
#login-logo {
    width: 60%;
    margin: 0 auto;
}
#loginbox {
    width: 100%;
    background: #2E363F;
    overflow: hidden;
    padding-bottom: 8%;
}
#login, #recover {
    width: 30%;
    border: 1px solid #3d4752;
    margin: 8% auto 0 auto;
    border-right: none;
    border-left: 0;
}
#login h3 {
    text-align: center;
    color: #fff;
}

.user-selector {
	width: 100%;
}

.btn-success {
    color: #fff;
    background-color: #5cb85c;
    border-color: #4cae4c;
}
</style>
